import { TOKEN_KEY } from "../../constants";
import { mainApi } from "../config";

export interface Account {
  id: string;
  email: string;
  name?: string;
}

export interface RegisterCredentials {
  email: string;
  password: string;
  name: string;
}

export interface AuthResponse {
  token: string;
  account: Account;
}

export interface ApiResponse<T> {
  data: T;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

// Register user
export async function register(
  credentials: RegisterCredentials
): Promise<boolean> {
  try {
    const response = await mainApi.post<ApiResponse<AuthResponse>>(
      "/accounts",
      credentials
    );

    return response.status === 201;
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function verifyToken(): Promise<Account> {
  try {
    const response = await mainApi.get<Account>("/check-token");
    return response.data;
  } catch (error) {
    throw new Error("something went wrong");
  }
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

// Check if user is authenticated
export function isAuthenticated(): boolean {
  return !!getToken();
}

export async function verifyEmail(token: string): Promise<AuthResponse> {
  try {
    const response = await mainApi.post<AuthResponse>("/verify_email", {
      token,
    });
    return response.data;
  } catch (error: any) {
    throw new Error("Something went wrong");
  }
}

export async function login(
  credentials: LoginCredentials
): Promise<AuthResponse> {
  try {
    const response = await mainApi.post<AuthResponse>("/login", credentials);
    return response.data;
  } catch (error: any) {
    throw new Error("Something went wrong");
  }
}
